import * as React from 'react';
import { FromToControl } from '../../../../../common/components/from_to_control';
import { FOfferType } from '../../../../../utils/category';
import { TArea } from '../../../../state/advanced/area';
import { InlineBlock, InlineLabel, Row } from '../../markup';

export interface IAreaStateProps {
  totalAreaMin: number | undefined;
  totalAreaMax: number | undefined;
  roomAreaMin: number | undefined;
  roomAreaMax: number | undefined;
  livingAreaMin: number | undefined;
  livingAreaMax: number | undefined;
  kitchenAreaMin: number | undefined;
  kitchenAreaMax: number | undefined;
}

export interface IAreaDispatchProps {
  onMinAreaChanged(param: TArea, value: number | undefined): void;
  onMaxAreaChanged(param: TArea, value: number | undefined): void;
}

export interface IAreaOwnProps {
  offerType: FOfferType;
}

type TAreaProps = IAreaStateProps & IAreaDispatchProps & IAreaOwnProps;

export const Area: React.StatelessComponent<TAreaProps> = props => (
  <Row title={'Площадь, м\u00B2'}>
    <InlineLabel>общая&nbsp;</InlineLabel>
    <InlineBlock>
      <FromToControl
        rangeGroupStyle={{ width: 120 }}
        from={{
          value: props.totalAreaMin,
          placeholder: 'от',
          onValueChange: value => props.onMinAreaChanged('total_area', value),
        }}
        to={{
          value: props.totalAreaMax,
          placeholder: 'до',
          onValueChange: value => props.onMaxAreaChanged('total_area', value),
        }}
      />
    </InlineBlock>

    {(props.offerType & (FOfferType.Room | FOfferType.Bed)) !== 0 && <InlineLabel>комната&nbsp;</InlineLabel>}
    {(props.offerType & (FOfferType.Room | FOfferType.Bed)) !== 0 && (
      <InlineBlock>
        <FromToControl
          rangeGroupStyle={{ width: 120 }}
          from={{
            //из api площадь комнаты приходит как строка - был баг с отображениеим значений
            value: typeof props.roomAreaMin === 'string' ? +props.roomAreaMin : props.roomAreaMin,
            placeholder: 'от',
            onValueChange: value => props.onMinAreaChanged('room_area', value),
          }}
          to={{
            value: typeof props.roomAreaMax === 'string' ? +props.roomAreaMax : props.roomAreaMax,
            placeholder: 'до',
            onValueChange: value => props.onMaxAreaChanged('room_area', value),
          }}
        />
      </InlineBlock>
    )}

    <InlineLabel>кухня&nbsp;</InlineLabel>
    <InlineBlock>
      <FromToControl
        rangeGroupStyle={{ width: 120 }}
        from={{
          value: props.kitchenAreaMin,
          placeholder: 'от',
          onValueChange: value => props.onMinAreaChanged('kitchen', value),
        }}
        to={{
          value: props.kitchenAreaMax,
          placeholder: 'до',
          onValueChange: value => props.onMaxAreaChanged('kitchen', value),
        }}
      />
    </InlineBlock>

    {(props.offerType & (FOfferType.Flat | FOfferType.FlatShared)) !== 0 && <InlineLabel>жилая&nbsp;</InlineLabel>}
    {(props.offerType & (FOfferType.Flat | FOfferType.FlatShared)) !== 0 && (
      <InlineBlock>
        <FromToControl
          rangeGroupStyle={{ width: 120 }}
          from={{
            value: props.livingAreaMin,
            placeholder: 'от',
            onValueChange: value => props.onMinAreaChanged('living_area', value),
          }}
          to={{
            value: props.livingAreaMax,
            placeholder: 'до',
            onValueChange: value => props.onMaxAreaChanged('living_area', value),
          }}
        />
      </InlineBlock>
    )}
  </Row>
);
